class BracingDialogComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('configure-bracing-dialog', async () => this.configure(), true)
  }

  resetButton(id) {
    document.getElementById(id).classList.add('btn-default')
    document.getElementById(id).classList.remove('btn-primary')
  }

  configure() {
    document.getElementById('equal-bracing-form').classList.add('d-none')
    document.getElementById('custom-bracing-form').classList.add('d-none')

    this.resetButton('continuous-bracing-button')
    this.resetButton('equally-spaced-bracing-button')
    this.resetButton('custom-bracing-button')
    this.resetButton('unbraced-bracing-button')

    let project = activeProject

    if (project.design.bracingType === 'continuous') {
      document.getElementById('continuous-bracing-button').classList.add('btn-primary')
    } else if (project.design.bracingType === 'equal') {
      document.getElementById('equal-bracing-form').classList.remove('d-none')
      document.getElementById('equally-spaced-bracing-button').classList.add('btn-primary')
      updateEquallySpacedBracingForm()
    } else if (project.design.bracingType == 'custom') {
      document.getElementById('custom-bracing-form').classList.remove('d-none')
      document.getElementById('custom-bracing-button').classList.add('btn-primary')
      updateCustomBracingTable();
    } else if (project.design.bracingType == 'unbraced') {
      document.getElementById('unbraced-bracing-button').classList.add('btn-primary')
    }
  }

  onBracingButtonClick(id) {

    let idMap = {
      'continuous-bracing-button': 'continuous',
      'equally-spaced-bracing-button': 'equal',
      'custom-bracing-button': 'custom',
      'unbraced-bracing-button': 'unbraced'
    }

    let project = activeProject

    BracingManager.updateBracingType(project, idMap[id])

    this.configure()

    RedrawCanvas()

    document.dispatchEvent(new CustomEvent('bracing-changed'))
  }

  connectedCallback() {

    this.innerHTML = String.raw`
    <div class="modal-body text-center">
      <button class="btn btn-primary button-shadow" id='continuous-bracing-button'>Continuous Bracing</button>
      <button class="btn btn-default button-shadow" id='equally-spaced-bracing-button'>Equally Spaced</button>
      <button class="btn btn-default button-shadow" id='custom-bracing-button'>Custom</button>
      <button class="btn btn-default button-shadow" id='unbraced-bracing-button'>Completely Unbraced</button>
    </div>

    <div class="modal-body">
      <form id="equal-bracing-form">
        <table class="table" id="equal-bracing-table">
          <tr class="success">
            <td style='width:100px;'>Spacing @:</td>
            <td><input style='width:100px;' id='equal-bracing-spacing-input' type='text'
                name='equal-bracing-spacing-input' value='0' onchange="onEqualSpacedBracingChange()"/>
              O.C.</td>
          </tr>
          <tr class="success">
            <td style='width:100px;'>Starting @:</td>
            <td><input style='width:100px;' id='equal-bracing-start-input' type='text'
                name='equal-bracing-start-input' value='0'  onchange="onEqualSpacedBracingChange()"/>
              from left end</td>
          </tr>
        </table>
      </form>
    
      <form id="custom-bracing-form" name="custom-bracing-form">
        <table class="table">
          <tr class="success">
            <td style="width:120px;">New Brace @:</td>
            <td><input style="width:100px;" id="new-brace-location-input" type="text"
                name="new-brace-location-input" value='0"' onchange="onNewBraceLocationChange()"></td>
            <td><button id="add-brace-button" type="button" class="btn btn-sm btn-success"
                onclick="addBrace()">Add</button>
            </td>
          </tr>
        </table>
        <div id="custom-bracing-table"></div>
      </form>
    </div>
    `

    document.getElementById('continuous-bracing-button').onclick = (() => this.onBracingButtonClick('continuous-bracing-button'))
    document.getElementById('equally-spaced-bracing-button').onclick = (() => this.onBracingButtonClick('equally-spaced-bracing-button'))
    document.getElementById('custom-bracing-button').onclick = (() => this.onBracingButtonClick('custom-bracing-button'))
    document.getElementById('unbraced-bracing-button').onclick = (() => this.onBracingButtonClick('unbraced-bracing-button'))

    this.configure()
  }
}

customElements.define('bracing-dialog-component', BracingDialogComponent)

function onEqualSpacedBracingChange() {
  let id = 'equal-bracing-spacing-input'
  if (validateRequiredInput(id) && validateLengthInput(id) && validateBraceSpacing(id)) {
  }
  id = 'equal-bracing-start-input'
  if (validateRequiredInput(id) && validateLengthInput(id) && validateBraceLocation(id)) {
  }
}

function onNewBraceLocationChange() {
  let id = 'new-brace-location-input'
  if (validateRequiredInput(id) && validateLengthInput(id) && validateBraceLocation(id)) {
  }
}

function openModalBracingDialog() {
  document.dispatchEvent(new CustomEvent('configure-bracing-dialog'))
  bootstrap.Modal.getOrCreateInstance('#modal-bracing-dialog').show()
}


function closeModalBracingDialog() {
  let project = activeProject

  if (project.design.bracingType === 'equal' &&
    validateRequiredInput('equal-bracing-spacing-input') &&
    validateLengthInput('equal-bracing-spacing-input') &&
    validateBraceSpacing('equal-bracing-spacing-input') &&
    validateRequiredInput('equal-bracing-start-input') &&
    validateLengthInput('equal-bracing-start-input') &&
    validateBraceLocation('equal-bracing-start-input')) {
    BracingManager.addEquallySpacedBraces(
      project,
      wsParseLength(document.getElementById("equal-bracing-spacing-input").value),
      wsParseLength(document.getElementById('equal-bracing-start-input').value))
  }

  RedrawCanvas()
  $('#modal-bracing-dialog').modal('hide');
  document.dispatchEvent(new CustomEvent('bracing-changed'))
}

function updateEquallySpacedBracingForm() {
  let project = activeProject
  document.getElementById("equal-bracing-spacing-input").value = showSmallLengthWithUnits(project.design.getBraceSpacing())
  document.getElementById('equal-bracing-start-input').value = showSmallLengthWithUnits(project.design.getBracingStartLocation())
}

function updateCustomBracingTable() {
  // loop over braces and build a table showing them...
  let design = activeProject.design
  let str = '<table class="table">'
  for (let i in design.customBraces) {
    if (design.customBraces[i].isSupport) {
      str += "<tr class='grayout'>";
      str += "<td style='width:100px;'>";
      str += "<span class='ws-ui-disabled-font'>Brace @</span>";
      str += "</td>";
      str += "<td style='width:100px;' id='brace_" + i + "'>" + showFeetInches(design.customBraces[i].x) + "</td>";
      str += "<td style='width:100px;'><span><em>Support</em></span></td></tr>";
    } else {
      str += "<tr>";
      str += "<td style='width:100px;'>";
      str += "Brace @";
      str += "</td>";
      str += "<td style='width:100px;' id='brace_" + i + "'>" + showFeetInches(design.customBraces[i].x) + "</td>";
      str += "<td style='width:100px;'><button type='button' class='btn btn-sm btn-danger' data-toggle='modal' onclick='removeBrace(" + i + ");'>Remove</button></td></tr>";
    }
  }
  //str += "<tr class='info'><td colspan=3>Note: Supports assumed braced.</td></tr>";
  str += "</table>";

  str += `
  <div class="alert alert-info" role="alert">
      <strong>Note:</strong> Supports assumed braced.
  </div>`
  document.getElementById('custom-bracing-table').innerHTML = str
}

function addBrace() {
  let id = 'new-brace-location-input'
  if (validateRequiredInput(id) && validateLengthInput(id) && validateBraceLocation(id)) {
    const brace = wsParseLength(document.getElementById(id).value)
    if (BracingManager.addBrace(activeProject, brace, false)) {
      updateCustomBracingTable()
    }
  }
}

function removeBrace(index) {
  if (BracingManager.removeBrace(activeProject, index)) {
    updateCustomBracingTable()
  }
}


